import { render, staticRenderFns } from "./IdeaHeroBox.vue?vue&type=template&id=9bdaa03e&scoped=true&"
import script from "./IdeaHeroBox.vue?vue&type=script&lang=js&"
export * from "./IdeaHeroBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdaa03e",
  null
  
)

export default component.exports